export function safeCapture(event: string, payload: Record<string, unknown> = {}) {
  if (!import.meta.client) return;

  try {
    const { $clientPosthog } = useNuxtApp();
    $clientPosthog?.capture(event, payload);
  } catch (error) {
    if (import.meta.dev) console.warn("[PostHog] capture failed", error);
  }
}

export function safeIdentify(id: string, payload: Record<string, unknown> = {}) {
  if (!import.meta.client) return;

  try {
    const { $clientPosthog } = useNuxtApp();
    $clientPosthog?.identify(id, payload);
  } catch (error) {
    if (import.meta.dev) console.warn("[PostHog] identify failed", error);
  }
}
